import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from './AppSettings';
import { GigsumoConstants } from './GigsumoConstants';
import { responseObject } from './UserService';
import { ApiService } from './api.service';
import { GigsumoService } from './gigsumoService';
import { UtilService } from './util.service';

export type widgetData = Pick<responseObject, "userId" | "limit" | "searchAfterKey">;
export type InteractionwidgetData = Pick<responseObject, "userId" | "limit" | "searchAfterKey" | "interactionType">;

  export function updateStatusCheckBox(arr: any[] , checked : boolean, defaultC : boolean = true) : any[]{
    return [...arr].map(x =>{

      if(x.label === "Draft"){
        x.disable = checked ? false : true;
        if(defaultC){
          x.selected = x.selected ? (checked ? true : false) : false;
          if (!x.selected) {
            (arr.find(d => d.label === "All") ?? []).selected = false;
         }
        }
      }

      // if (x.disable) {
      //   (arr.find(d => d.label === "All") ?? {}).selected = true;
      // }

      return x;
    });
  }


@Injectable({
  providedIn: 'root',
})
export class JobService {
  private isSliderOpenSubject = new Subject<{ value: boolean, panel: string, filterData: any ,reset:boolean}>();
  private dataForFilterSubject = new BehaviorSubject<any>(null);
  private confirmationResultSubject = new Subject<void>(); // No need for any specific value here

  confirmationResult$ = this.confirmationResultSubject.asObservable();
  private reloadSubject = new BehaviorSubject<boolean>(false);
  static FILTER_ELEMENT = ["all", "myJobs", "marketPlaceJobs", "teamJobs", "recruiterNetworkJobs", "freeLancerNetworkJobs", "mtaNetworkJobs", "featured", "suggestedJobs" ,
    "businessNetwork" , "memberNetworksJobs"
  ];

  private dataForReset = new Subject<boolean>();
  colorMap: Map<string, string> = new Map();
  textMap: Map<string, string> = new Map();
  fullNameTextMap: Map<string, string> = new Map();


  private searchAfterKey: [string] = null;
  stopScroll: boolean = false;
  previousKey: string = null;
  userId: string = localStorage.getItem('userId');
  constructor(private API: ApiService, private util: UtilService,private formBuilder: FormBuilder) { }
  reloadComponent() {
    this.reloadSubject.next(true);
  }

  getReloadSignal() {
    return this.reloadSubject.asObservable();
  }
  getSearchAfterKey(): [string] {
    return this.searchAfterKey;
  }

  jobSourcefields(dataArr : any[]): FormGroup {
    let data  = [
      "all",
      "marketPlaceJobs",
      "myJobs",
      "myEmployees",
      "teamJobs",
      "recruiterNetworkJobs",
      "freeLancerNetworkJobs",
      "mtaNetworkJobs",
      "businessNetwork",
      "memberNetworksJobs",
      "eligibleSubContractJobs"
      // "featured",
      // "suggestedJobs",
    ].concat(dataArr.filter(
      c => !GigsumoService.FILTER_ITEMS().map(x => x.value).includes(c.networkName)
    ).map(x => x.networkId));

    let filterformGroup = {};
    data.forEach(x=>{
       filterformGroup[x] =  false;
    });

    return this.formBuilder.group(filterformGroup);
  }


  confirmResult() {
    this.confirmationResultSubject.next(); // Emit the confirmation signal
  }

  findActieJobs(data: widgetData): Observable<any> {

    return this.API.create("jobs/findActiveJobs", data).pipe(
      map(response => {
        this.util.stopLoader();

        if (response.code && response.code !== "00000") {
          throw new Error("There is some issue with Server");
        }
        if (response.data && response.data.jobList) {

          response.data.jobList.forEach(ele => {
            if (ele.user) {
              if (ele.user.photo != null) {
                ele.user.photo = AppSettings.photoUrl + ele.user.photo;
              } else {

                ele.user.photo = null;
              }
            }
          });

          response.data.jobList = [...response.data.jobList];
        }
        return response.data;
      })
    );
  }


  findJobAppliedByTheUser(data: widgetData): Observable<any> {
    return this.API.create("jobs/findJobAppliedByTheUser", data).pipe(
      map(response => {
        return response.data;
      })
    );
  }

  responseBody = {
    userId: this.userId,
    limit: 4,
    searchAfterKey: null
  };


  findByJobId(jobId: string): Observable<any> {
    return this.API.query("jobs/findJobById/" + jobId).pipe(
      map(response => {
        if (response != null) {
          if (response.code && response.code != GigsumoConstants.SUCESSCODE) {
            throw new Error("There is some issue with Server");
          }
          return response.data;
        }
      })
    );
  }

  updateJobViewed(data: any): Observable<any> {
    return this.API.updatePut("jobs/updateJobViewed", data).pipe(
      map(response => {
        if (response != null) {
          if (response.code && response.code != GigsumoConstants.SUCESSCODE) {
            throw new Error("There is some issue with Server");
          }
          return response;
        }
      })
    );
  }


  findUserInteractionsForThePlan(data: InteractionwidgetData): Observable<any> {

    return this.API.create("jobs/findUserInteractionsForThePlan", data).pipe(
      map(response => {
        this.util.stopLoader();
        if (response != null) {

          if (response.code && response.code != GigsumoConstants.SUCESSCODE) {
            throw new Error("There is some issue with Server");
          }

          if (response.data && response.data.jobsApplied) {

            response.data.jobsApplied.forEach(ele => {
              if (ele.user) {
                if (ele.user.photo != null) {
                  // Prevent double URL prepending
                  if (!ele.user.photo.startsWith('http://') && !ele.user.photo.startsWith('https://')) {
                    ele.user.photo = AppSettings.photoUrl + ele.user.photo;
                  }
                } else {
                  ele.user.photo = null;
                }
              }
            });
            response.data.jobsApplied = [...response.data.jobsApplied];
          }
          if (response.data && response.data.resumesDownloaded) {

            response.data.resumesDownloaded.forEach(ele => {
              if (ele.user) {
                if (ele.user.photo != null) {
                  // Prevent double URL prepending
                  if (!ele.user.photo.startsWith('http://') && !ele.user.photo.startsWith('https://')) {
                    ele.user.photo = AppSettings.photoUrl + ele.user.photo;
                  }
                } else {
                  ele.user.photo = null;
                }
              }
            });
            response.data.resumesDownloaded = [...response.data.resumesDownloaded];
          }
          // Process candidatesInvitations if present
          if (response.data && response.data.candidatesInvitations) {
            response.data.candidatesInvitations.forEach(ele => {
              if (ele.user && ele.user.photo != null) {
                if (!ele.user.photo.startsWith('http://') && !ele.user.photo.startsWith('https://')) {
                  ele.user.photo = AppSettings.photoUrl + ele.user.photo;
                }
              }
            });
            response.data.candidatesInvitations = [...response.data.candidatesInvitations];
          }
          // Process resumeRequests if present
          if (response.data && response.data.resumeRequests) {
            response.data.resumeRequests.forEach(ele => {
              if (ele.user && ele.user.photo != null) {
                if (!ele.user.photo.startsWith('http://') && !ele.user.photo.startsWith('https://')) {
                  ele.user.photo = AppSettings.photoUrl + ele.user.photo;
                }
              }
            });
            response.data.resumeRequests = [...response.data.resumeRequests];
          }
          return response.data;
        }
      })
    )
  }

  setSliderToggle(value: boolean, panel: string, filterData: any,reset: boolean): void {
    this.isSliderOpenSubject.next({ value, panel, filterData,reset });
  }

  getSliderToggle(): Observable<any> {
    return this.isSliderOpenSubject.asObservable();
  }

  setDataForFilter(data: any): void {
    this.dataForFilterSubject.next(data);
  }

  getDataForFilter(): Observable<any> {
    return this.dataForFilterSubject.asObservable();
  }

  setReset(data: boolean): void {
    this.dataForReset.next(data);
  }

  getReset(): Observable<boolean> {
    return this.dataForReset.asObservable();
  }

  getInitials(fullname: string): string {
    if (!fullname || typeof fullname !== 'string') {
      return '';
    }

    // Check if the full name has spaces
    if (fullname.includes(' ')) {
      // if (words.length > 2) {
      //   const firstTwoWords = words.slice(0, 2);
      //   const initials = firstTwoWords.map(word => word.charAt(0)).join('');
      //   return initials.toUpperCase();
      // } else {
      //   const initials = words.map(word => word.charAt(0)).join('');
      //   return initials.toUpperCase();
      // }
      const words = fullname.split(' ');
      let initials = '';
      initials += words[0].charAt(0);
      const lastname = words[words.length - 1];
      initials += lastname.charAt(0);
      return initials.toUpperCase();
    } else {
      const initials = fullname.substr(0, 2);
      return initials.toUpperCase();
    }
  }

  getTextColor(firstname: string | undefined, lastname: string | undefined): string {
    const fullName = `${firstname} ${lastname}`;

    if (!this.textMap.has(fullName)) {
      this.textMap.set(fullName, this.readableTextFor(this.getColorparam(`${firstname}`, `${lastname}`)));
    }

    return this.textMap.get(fullName) || '';
  }

  // Same hue as the avatar background, darkened until it reaches WCAG AA
  // contrast (4.5:1) so initials stay readable on any generated background.
  private relativeLuminance(r: number, g: number, b: number): number {
    const lin = (c: number) => {
      const v = c / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  }

  private readableTextFor(bgHex: string): string {
    const rgb = this.hexToRgb(bgHex);
    if (!rgb) {
      return '#1F2937';
    }
    const bgLum = this.relativeLuminance(rgb[0], rgb[1], rgb[2]);
    let scale = 0.6;
    let r = 0, g = 0, b = 0;
    for (let i = 0; i < 20; i++) {
      r = Math.round(rgb[0] * scale);
      g = Math.round(rgb[1] * scale);
      b = Math.round(rgb[2] * scale);
      const contrast = (bgLum + 0.05) / (this.relativeLuminance(r, g, b) + 0.05);
      if (contrast >= 4.5) {
        break;
      }
      scale -= 0.03;
    }
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
  }

  getFullnameTextColor(username: string | undefined): string {
    if (!username) {
      return '';
    }

    if (!this.fullNameTextMap.has(username)) {
      this.fullNameTextMap.set(username, this.readableTextFor(this.getColor(username)));
    }

    return this.fullNameTextMap.get(username) || '';
  }

  // Hardcoded fallback in case a CSS var isn't resolvable (e.g. not on :root
  // yet). Kept in sync with src/index.html's --primary-color and
  // src/styles/tokens.scss's --gs-purple-bg.
  private readonly fallbackThemeColors: [number, number, number][] = [
    [139, 92, 246],  // --primary-color #8B5CF6
    [237, 233, 254], // unread row tint #EDE9FE (not a CSS var, hardcoded in notification.component.scss)
    [245, 243, 255], // --gs-purple-bg #F5F3FF
  ];

  private cachedThemeColors: [number, number, number][] | null = null;

  private hexToRgb(hex: string): [number, number, number] | null {
    const match = hex.trim().match(/^#?([0-9a-f]{6})$/i);
    if (!match) {
      return null;
    }
    const n = parseInt(match[1], 16);
    return [(n >> 16) & 0xFF, (n >> 8) & 0xFF, n & 0xFF];
  }

  // Reads the live --primary-color / --gs-purple-bg CSS custom properties
  // off :root so this tracks the actual theme instead of a hardcoded guess.
  // Cached after the first read since these don't change at runtime.
  private getThemeColors(): [number, number, number][] {
    if (this.cachedThemeColors) {
      return this.cachedThemeColors;
    }

    const colors = [...this.fallbackThemeColors];

    if (typeof document !== 'undefined' && document.documentElement) {
      const rootStyles = getComputedStyle(document.documentElement);
      const primary = this.hexToRgb(rootStyles.getPropertyValue('--primary-color'));
      const purpleBg = this.hexToRgb(rootStyles.getPropertyValue('--gs-purple-bg'));

      if (primary) {
        colors.push(primary);
      }
      if (purpleBg) {
        colors.push(purpleBg);
      }
    }

    this.cachedThemeColors = colors;
    return colors;
  }

  private isCloseToThemeColor(r: number, g: number, b: number): boolean {
    return this.getThemeColors().some(([tr, tg, tb]) => {
      const distance = Math.sqrt((r - tr) ** 2 + (g - tg) ** 2 + (b - tb) ** 2);
      return distance < 60;
    });
  }

  // Same pastel formula as before (0.2/0.8 blend toward white) - unchanged
  // so the generated look stays identical. Only the seed hash changes when
  // we need to avoid the theme color.
  private pastelFromHash(hash: number): [number, number, number] {
    const r = (hash & 0xFF0000) >> 16;
    const g = (hash & 0x00FF00) >> 8;
    const b = hash & 0x0000FF;

    const pastelFactor = 255;
    return [
      Math.floor(r * 0.3 + pastelFactor * 0.7),
      Math.floor(g * 0.3 + pastelFactor * 0.7),
      Math.floor(b * 0.3 + pastelFactor * 0.7),
    ];
  }

  getColor(username: string): string {
    if (!username) {
      return '';
    }

    let hash = 0;
    for (let i = 0; i < username.length; i++) {
      hash = username.charCodeAt(i) + ((hash << 5) - hash);
    }

    let [pastelR, pastelG, pastelB] = this.pastelFromHash(hash);

    // Too close to the theme purple / highlighted-row color: reseed the hash
    // (same pastel formula, different starting point) until it isn't.
    let attempts = 0;
    while (this.isCloseToThemeColor(pastelR, pastelG, pastelB) && attempts < 10) {
      hash = hash + 97;
      [pastelR, pastelG, pastelB] = this.pastelFromHash(hash);
      attempts++;
    }


    const color = `#${((1 << 24) + (pastelR << 16) + (pastelG << 8) + pastelB).toString(16).slice(1).toUpperCase()}`;


    if (!this.colorMap.has(username)) {
      this.colorMap.set(username, color);
    }

    return this.colorMap.get(username) || '';
  }

  getInitialsparam(firstname: string, lastname: string): string {
    if (!firstname || !lastname) {
      return '';
    }

    if (firstname.includes(' ') || lastname.includes(' ')) {
      const fullname = firstname + ' ' + lastname;
      const words = fullname.split(' ');
      let initials = '';
      initials += words[0].charAt(0);
      const endingName = words[words.length - 1];
      initials += endingName.charAt(0);
      return initials.toUpperCase();
    } else {
      const initials = `${firstname.charAt(0)}${lastname.charAt(0)}`;
      return initials.toUpperCase();
    }
  }

  getColorparam(firstname: string, lastname: string): string {
    const fullName = `${firstname} ${lastname}`;

    let hash = 0;
    for (let i = 0; i < fullName.length; i++) {
      hash = fullName.charCodeAt(i) + ((hash << 5) - hash);
    }

    let [pastelR, pastelG, pastelB] = this.pastelFromHash(hash);

    // Too close to the theme purple / highlighted-row color: reseed the hash
    // (same pastel formula, different starting point) until it isn't.
    let attempts = 0;
    while (this.isCloseToThemeColor(pastelR, pastelG, pastelB) && attempts < 10) {
      hash = hash + 97;
      [pastelR, pastelG, pastelB] = this.pastelFromHash(hash);
      attempts++;
    }


    const color = `#${((1 << 24) + (pastelR << 16) + (pastelG << 8) + pastelB).toString(16).slice(1).toUpperCase()}`;


    if (!this.colorMap.has(fullName)) {
      this.colorMap.set(fullName, color);
    }

    return this.colorMap.get(fullName) || '';
}
}
